import script from "./UFilterObj.vue?vue&type=script&setup=true&lang=ts"
export * from "./UFilterObj.vue?vue&type=script&setup=true&lang=ts"

import "./UFilterObj.vue?vue&type=style&index=0&id=79cd512d&lang=css"

const __exports__ = script;

export default __exports__